<template>
    <v-container fluid class="pt-0">
        <v-row>

            <v-col cols="12" class="pa-0">
                <v-sheet class="" color="#008dd4" height="10vh"></v-sheet>
            </v-col>

            <v-col cols="12" lg="3" style="position:relative; top: -60px">
                <v-card>
                    <v-list two-line subheader>
                        <v-list-item>
                            <v-list-item-avatar>
                                <v-icon color="#008dd4" x-large>mdi-account</v-icon>
                            </v-list-item-avatar>

                            <v-list-item-content>
                                <v-list-item-title><strong>Registro total de Alumnos</strong></v-list-item-title>
                                <v-list-item-subtitle class="text-h4">{{ items.length }}</v-list-item-subtitle>
                            </v-list-item-content>

                        </v-list-item>
                    </v-list>
                </v-card>


                <v-btn class="mt-3" block color="success" @click="recovery_mails_dialog = !recovery_mails_dialog">Recuperación</v-btn>

                
            </v-col>

            <v-col cols="12" lg="9" style="position:relative; top: -60px">

                <v-card>
                    <v-data-table
                        :headers="headers"
                        :items="items"
                        :loading="loading"
                        :footer-props="footer_props"
                        :loading-text="loading_text"
                        :no-data-text="no_data_text"
                        :no-results-text="no_result_text"
                        :search="search"
                    >
                        <template v-slot:top>
                            <v-container class="py-0">
                                <v-row justify="center" align="center">
                                    <v-col cols="12" lg="6">
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn fab color="#008dd4" v-bind="attrs" v-on="on" @click="create_dialog = !create_dialog" dark>
                                                    <v-icon>mdi-account-plus</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Nuevo registro</span>
                                        </v-tooltip>

                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn fab color="#008dd4" v-bind="attrs" v-on="on" dark>
                                                    <v-icon>mdi-file-pdf</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Exportar</span>
                                        </v-tooltip>

                                    </v-col>
                                    <v-col cols="12" lg="6">
                                        <v-text-field
                                            v-model="search"
                                            clearable
                                            dense
                                            outlined
                                            hide-details
                                            label="Buscar"
                                            append-icon="mdi-magnify"
                                            color="#818181"
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </template>

                        <template v-slot:item.status="{ item }">
                            <v-chip color="success" v-if="item.status">Habilitado</v-chip>
                            <v-chip color="error" v-else>Deshabilitado</v-chip>
                        </template>

                        <template v-slot:item.actions="{ item }">

                            <v-menu offset-y>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn icon v-bind="attrs" v-on="on">
                                        <v-icon>mdi-account-edit</v-icon>
                                    </v-btn>
                                </template>
                                <v-list dense>
                                    <v-list-item class="px-0">
                                        <v-list-item-content>
                                            <v-btn small text @click="show(item)">Mostrar</v-btn>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item class="px-0">
                                        <v-list-item-content>
                                            <v-btn small text @click="edit(item)">Editar</v-btn>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item class="px-0" v-if="item.student_course">
                                        <v-list-item-content>
                                            <v-btn small text @click="changeCourse(item)">Cambio de curso</v-btn>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item class="px-0" v-if="item.student_course && item.schedule_changes && item.schedule_changes.length > 0">
                                        <v-list-item-content>
                                            <v-btn small text @click="scheduleChanges_action(item)">Historial de cambios</v-btn>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item class="px-0">
                                        <v-list-item-content>
                                            <v-btn small text @click="status(item)">{{ item.status ? 'Deshabilitar': 'Habilitar' }}</v-btn>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item class="px-0">
                                        <v-list-item-content>
                                            <v-btn small text @click="remove(item)">Eliminar</v-btn>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                            </v-menu>

                            <v-menu offset-y>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn icon v-bind="attrs" v-on="on">
                                        <v-icon>mdi-account-cash</v-icon>
                                    </v-btn>
                                </template>
                                <v-list dense>
                                    <v-list-item class="px-0">
                                        <v-list-item-content>
                                            <v-btn small text @click="() => { billing_item = item; billing_dialog = !billing_dialog }">Facturación</v-btn>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item class="px-0">
                                        <v-list-item-content>
                                            <v-btn small text @click="() => { getCoursesForStudent(item); inscriptions_item = item; inscriptions_dialog = !inscriptions_dialog }">Inscripciones</v-btn>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item class="px-0">
                                        <v-list-item-content>
                                            <v-btn small text>Referidos</v-btn>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                        </template>
                    </v-data-table>
                </v-card>
            </v-col>
        </v-row>

        <v-dialog v-model="recovery_mails_dialog" persistent max-width="400">
            <v-card>
                <v-card-title>Atención</v-card-title>
                <v-card-text class="text-center">
                    <p>Se enviará un correo electrónico a todos los estudiantes que no estén registrados en ningún curso. <br>Esta acción puede tardar varíos minutos.</p>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text color="#000" @click="recovery_mails_dialog = false" :disabled="recovery_mails_loading">Cancelar</v-btn>
                    <v-btn color="#008dd4" dark :loading="recovery_mails_loading" @click="recovery_mails">Aceptar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <show :dialog="show_dialog" :item="show_item"></show>
        <create :dialog="create_dialog" :store_url="store_url"></create>
        <edit :dialog="edit_dialog" :item="edit_item" :update_url="update_url"></edit>
        <status :dialog="status_dialog" :item="status_item" :status_url="status_url"></status>
        <remove :dialog="delete_dialog" :item="delete_item" :delete_url="delete_url"></remove>
        <billing :dialog="billing_dialog" :student="billing_item"></billing>
        <changeCourse :dialog="change_course_dialog" :item="change_course_item" :courses="courses" :post_url="change_course_url"></changeCourse>
        <scheduleChanges :dialog="schedule_changes_dialog" :item="schedule_changes_item"></scheduleChanges>
        <inscriptions :dialog="inscriptions_dialog" :item="inscriptions_item" :courses="coursesAvailibles"></inscriptions>

    </v-container>
</template>
<script>

import show from './show'
import edit from './edit'
import create from './create'
import status from './status'
import remove from './remove'
import billing from './billing'
import iziToast from 'izitoast'
import inscriptions from './inscriptions'
import changeCourse from './changeCourse'
import scheduleChanges from './scheduleChanges'

export default {
    components:{
        show,
        create,
        edit,
        status,
        remove,
        billing,
        changeCourse,
        scheduleChanges,
        inscriptions,
    },

    data: () => ({
        //URL's
        get_data:"/students",
        store_url:"/students/store",
        update_url:"/students/update",
        status_url:"/students/status",
        delete_url:"/students/delete",
        courses_url:"/courses/courses_availables",
        courses_student:"/courses/courses_for_student/",
        change_course_url:"/students/change_course",
        recovery_mails_url:"/students/recovery_mails",

        //props
        items:[],
        courses:[],
        coursesAvailibles:[],

        //items
        show_item:"",
        edit_item:"",
        status_item:"",
        delete_item:"",
        billing_item:"",
        change_course_item:"",
        schedule_changes_item:"",
        inscriptions_item:"",

        //loadings
        recovery_mails_loading:false,

        //dialogs
        create_dialog:false,
        show_dialog:false,
        edit_dialog:false,
        status_dialog:false,
        delete_dialog:false,
        billing_dialog:false,
        change_course_dialog:false,
        schedule_changes_dialog:false,
        recovery_mails_dialog:false,
        inscriptions_dialog:false,

        //data table props
        color:"#818181",
        search:"",
        loading:"#008dd4",
        loading_text:"Cargando...",
        no_data_text:"Sin elementos registrados",
        no_result_text:"Sin coincidencias",
        headers:[
            { text:'ID', value:'id' },
            { text:'Nombre(s)', value:'fullname' },
            { text:'Teléfono', value:'phone'},
            { text:'Correo', value:'email' },
            { text:'status', value:'status' },
            { text: 'Acciones', value:'actions', sorteable:false}
        ],
        footer_props:{
            itemsPerPageText:"Filas por página",
            showCurrentPage:true,
            itemsPerPageAllText:"Todo",
            showFirstLastPage:true,
        }
    }),

    mounted(){
        this.getData()
    },

    methods:{
        getData:function(){
            this.loading = true
            axios.get(this.get_data, { params:{ ajax:true } }).then(response => {
                this.items = response.data.items
                this.loading = false
            }).catch(error =>{})
        },
        getCoursesForStudent:function(item){
            axios.get(this.courses_student + item.id ,  { params:{ ajax:true } }).then(response =>{
                this.coursesAvailibles = response.data.courses
            }).catch(error =>{})
        },

        getCoursesAvailables:function(){
            axios.get(this.courses_url , { params:{ ajax:true } }).then(response =>{
                this.courses = response.data.courses
            }).catch(error =>{})
        },

        getItem:function(item){
            return Object.assign({}, this.items[this.items.indexOf(item)])
        },

        show:function(item){
            this.show_item = this.getItem(item)
            this.show_dialog = true
        },

        edit:function(item){
            this.edit_item = this.getItem(item)
            this.edit_dialog = true
        },

        status:function(item){
            this.status_item = this.getItem(item)
            this.status_dialog = true
        },

        remove:function(item){
            this.delete_item = this.getItem(item)
            this.delete_dialog = true
        },

        changeCourse:function(item){
            this.getCoursesAvailables()
            this.change_course_item = item
            this.change_course_dialog = true
        },

        scheduleChanges_action:function(item){
            this.schedule_changes_item = item
            this.schedule_changes_dialog = true
        },

        recovery_mails:function(){
            this.recovery_mails_loading = true
            axios.post(this.recovery_mails_url).then(response => {
                this.recovery_mails_dialog = this.recovery_mails_loading = false
                izitoast.success({
                    title:"Correcto",
                    message:"Correos enviados correctamente",
                    position:"topRight"
                })
            }).catch(error => {
                iziToast.error({
                    title:"Error",
                    message:"Ha ocurrido un error en la comunicación con el servidor",
                    position:"topRight"
                })

                console.log(error.response)
            })
        }
    }
}
</script>
